// Set negative margin on 100vw blocks on screen size > breakpoint.sm, set margin = 0 on screen size < breakpoint.sm

//Do not run in episer edit mode
if (!$('body').data('editmode')) {
    
    var breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1260
    };

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    $.fn.setFullWidthMargin = function () {
        var mainContainer = $('#main-content > .container')

        if($(mainContainer).offset()){
            var containerOffset = $(mainContainer).offset().left;

            if (containerOffset) {
                if($(mainContainer.find('.block__full-width').length > 0)) {
                    mainContainer.find('.block__full-width').css({'margin-left': - containerOffset - 15, 'opacity': 1, 'width': $(window).width()});
                }
            }
        }

    };

    if (viewportWidth > breakpoints.sm) {
        $(this).setFullWidthMargin();
    }
    else {
        $('.block__full-width').css({'margin-left': - 15, 'opacity': 1, 'width': $(window).width()});
    }

    $(window).resize(function() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (viewportWidth > breakpoints.sm) {
            $(this).setFullWidthMargin();
        } else {
            var mainContainer = $('#main-content > .container');
            if($(mainContainer.find('.block__full-width').length > 0)) {
                mainContainer.find('.block__full-width').css({'margin-left': - 15, 'opacity': 1, 'width': $(window).width()});
            }
        }
    });

    //Make sure the event triggers at least once
    $(window).on('load', function () {
        $(window).trigger('resize');
    });
}
